import React from 'react'
import { Grid, Button, Header, Segment } from 'semantic-ui-react'
import styles from './NotFoundStyles'

const NotFound = ({ history }) => (
  <Grid textAlign='center' verticalAlign='middle'>
    <Grid.Column className={styles.grid}>
      <Segment padded='very'>
        <Header as='h2' textAlign='center'>
          404 Not Found
        </Header>
        <Button onClick={() => history.push('/')}>Go To Home</Button>
      </Segment>
    </Grid.Column>
  </Grid>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/Pages/Layouts/NotFound.js